import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmusersetmeal/cecUnmUserSetMeal/import',
      method: 'post',
      data: data
    })
  }
}
